import { UI_LANGUAGES } from '@/Domain/enum/SupportLanguage.enum';

export const ENTRY_ONLY_LANGUAGES = [
  { code: 'ar', label: 'العربية' },
  { code: 'id', label: 'Bahasa Indonesia' },
  { code: 'ru', label: 'Русский' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'zh-tw', label: '繁體中文' },
  { code: 'th', label: 'ไทย' },
  { code: 'it', label: 'Italiano' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'uk', label: 'Українська' },
  { code: 'he', label: 'עברית' },
  { code: 'ko', label: '한국어' },
  { code: 'tr', label: 'Türkçe' },
] as const;

export const ENTRY_LANGUAGES = [...UI_LANGUAGES, ...ENTRY_ONLY_LANGUAGES];
export const ENTRY_LANGUAGE_CODES: string[] = ENTRY_LANGUAGES.map(({ code }) => code);

export const isEntryOnlyLanguage = (language: string): boolean =>
  ENTRY_ONLY_LANGUAGES.some(({ code }) => code === language);

export const consumeEntryLocale = (): string | undefined => {
  const url = new URL(window.location.href);
  const language = url.searchParams.get('qc_locale');
  if (language === null) return undefined;

  url.searchParams.delete('qc_locale');
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  return ENTRY_LANGUAGE_CODES.includes(language) ? language : undefined;
};

export const entryMarketingUrl = (
  path: '/' | '/helpdesk' | '/shopify',
  language: string,
): string => {
  const supported =
    ENTRY_LANGUAGE_CODES.includes(language) &&
    (path === '/' || !['he', 'ko', 'tr'].includes(language));
  const prefix = supported && language !== 'en' ? `/${language}` : '';
  return `https://quickchat.ai${prefix}${path}`;
};
